export enum WeeklyUpdateModalModes {
  VIEW = "view",
  CREATE = "create",
  EDIT = "edit",
}
